import axios, {AxiosResponse} from 'axios';
import {
  CreateReceiptBody,
  CreateReceiptDTO,
  CreateReceiptResponse,
  MatchInvoiceResponse,
  MatchInvoicesRequest,
  MatchSourceRow
} from '../types';
import {CancellationHandlers} from '../../_common/types';

export const MATCH_INVOICES = '/bankStatements/findMatchInvoicesList';
export const CREATE_RECEIPT = '/receipts/createReceipt';

export const matchInvoices = async (bankTransactions: MatchSourceRow[], cancellationHandlers: CancellationHandlers) => {
  return axios.post<
    MatchInvoiceResponse,
    AxiosResponse<MatchInvoiceResponse>,
    MatchInvoicesRequest
  >(
    MATCH_INVOICES,
    {bankTransactions},
    {...cancellationHandlers}
  );
};

export const createReceipt = async (
  data: CreateReceiptDTO,
  cancellationHandlers: CancellationHandlers
) => {
  return axios.post<
    CreateReceiptResponse,
    AxiosResponse<CreateReceiptResponse>,
    CreateReceiptBody
  >(CREATE_RECEIPT, data, {...cancellationHandlers});
};